import { useTranslation } from 'next-i18next';
import React, { useEffect, useState } from 'react';
import { shallowEqual, useDispatch } from 'react-redux';
import usePagebuilder from '../../../../hooks/pagebuilder/usePagebuilder';
import { setPageBuilder } from '../../../../reduxToolkit/slices/commonSlice';
import { useSelector } from '../../../../reduxToolkit/typedRedux';
import PageBgOverlay from '../../pageBuilder/PageBgOverlay';
import PageBuilderContent from '../../pageBuilder/PageBuilderContent';
import EventHome from './EventHome';
import ReactPlayerPipPopup from './ReactPlayerPipPopup';
import WithoutPageBuilder from './WithoutPageBuilder';

const MainContent = () => {
  const { event, pagedata, pagebuilder, user, pages } = useSelector(
    ({ common: { event, pagedata, pagebuilder, user, pages } }) => ({ event, pagedata, pagebuilder, user, pages }),
    shallowEqual
  );
  const isMobilePreview = useSelector((state) => state.common.isMobilePreview);

  const [template, setTemplate] = useState<any>(pagedata?.template);
  const [hasAccess, setHasAccess] = useState<boolean>(false);

  const dispatch = useDispatch();

  const { t } = useTranslation('event');
  const { isPagebuilderActive } = usePagebuilder();

  useEffect(() => {
    if (user && user.role !== 'PARTICIPANT_ANONYM') {
      dispatch(
        setPageBuilder({
          ...pagebuilder,
          originalpagedata: pagedata,
          currentpagedata: pagedata,
          originalcomponents: pagedata?.uicomponents || [],
          currentcomponents: pagedata?.uicomponents || [],
          originalcolumncomponents: pagedata?.uicolumncomponents || [],
          currentcolumncomponents: pagedata?.uicolumncomponents || [],
        })
      );
    }
    setTemplate(pagedata?.template);
  }, [user, pagedata]);

  useEffect(() => {
    if (pagedata && pages) {
      const pageIds = pages.map((p) => p._id);
      const match = pageIds.includes(pagedata._id);
      setHasAccess(!!match);
    }
  }, [pagedata, pages]);

  if (!event) return <></>;

  return (
    <>
      {isMobilePreview && <PageBgOverlay />}
      <main>
        {template?.siteTemplate === 'eventhome' && (
          <div className="w-4/5">
            <EventHome />
          </div>
        )}

        <>
          {hasAccess ? (
            <>{isPagebuilderActive() ? <PageBuilderContent isLandingPage={false} /> : <WithoutPageBuilder />}</>
          ) : (
            <>
              {pages?.length > 0 && (user?.role === 'PARTICIPANT_ANONYM' || !user) ? (
                <div className="w-full text-center mt-12 text-xl text-black bg-white p-12">{t('event:no-access-with-registration')}</div>
              ) : (
                <></>
              )}
            </>
          )}
        </>
        <ReactPlayerPipPopup />
      </main>
    </>
  );
};

export default MainContent;
